import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { StructureList } from './StructureList';
import { ActionPermissions, CustomPermission } from '../../@types';
import { Button, ButtonVariantProps } from '../../components/atoms/Button';
import { InlineGroup, HorizontalAlignProps } from '../../components/atoms/InlineGroup';
import { Link } from '../../components/atoms/Link';
import { PageContainer } from '../../components/atoms/PageContainer';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { PLATFORM_NAME } from '../../configs/common';
import { isUserHasPermission } from '../../configs/permissions';
import { TabHandler } from '../../handlers/TabHandler';
import { useGetUserSystemPermissions } from '../../queries/user-query';
import { Wrapper } from '../../styled/common.styles';
import { getCreateStructurePageUrl } from '../../utils/structure';

export const Structures: React.FC = () => {
  const location = useLocation();
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  TabHandler(`List Structure | ${PLATFORM_NAME}`);
  
  return (
    <PageContainer>
      <Wrapper>
        <InlineGroup horizontal={HorizontalAlignProps.Between}>
          <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
            List Structure
          </Typography>
          {isUserHasPermission(ActionPermissions.Structure_Create_General, permissions) && (
            <Link href={getCreateStructurePageUrl(location.pathname)}>
              <Button variant={ButtonVariantProps.Primary} startIcon={<AddIcon />}>
                Create Structure
              </Button>
            </Link>
          )}
        </InlineGroup>
        <StructureList />
      </Wrapper>
    </PageContainer>
  );
};